import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { ATMSettings } from './ATMSettings';

export class ATMSettingsResource extends FBaseService {
  public async getATMSettings(fiId: string): Promise<ATMSettings> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/config/${fiId}/atm/`,
    );
    return response.data.data;
  }
}

export default ATMSettingsResource;
